"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ReasonToCancelTaskType = exports.ReasonOrderType = void 0;
var ReasonOrderType;
(function (ReasonOrderType) {
    ReasonOrderType[ReasonOrderType["NONE"] = 0] = "NONE";
    ReasonOrderType[ReasonOrderType["PICKUP"] = 1] = "PICKUP";
    ReasonOrderType[ReasonOrderType["DROPOFF"] = 2] = "DROPOFF";
    ReasonOrderType[ReasonOrderType["PICKUP_AND_DROPOFF"] = 3] = "PICKUP_AND_DROPOFF";
    ReasonOrderType[ReasonOrderType["CURBSIDE"] = 6] = "CURBSIDE";
})(ReasonOrderType || (exports.ReasonOrderType = ReasonOrderType = {}));
var ReasonToCancelTaskType;
(function (ReasonToCancelTaskType) {
    ReasonToCancelTaskType["CUSTOMER_WAS_NOT_AT_DESTINATION"] = "customer_was_not_at_destination";
    ReasonToCancelTaskType["CUSTOMER_REFUSED_TO_ACCEPT"] = "customer_refused_to_accept";
    ReasonToCancelTaskType["INCORRECT_ADDRESS"] = "incorrect_address";
    ReasonToCancelTaskType["DAMAGED_GOODS"] = "damaged_goods";
    ReasonToCancelTaskType["TECHNICAL_DIFFICULTIES"] = "technical_difficulties";
    ReasonToCancelTaskType["OTHER"] = "other";
    ReasonToCancelTaskType["RESERVATION_EXPIRED"] = "reservation_expired";
    ReasonToCancelTaskType["CUSTOM"] = "custom";
    ReasonToCancelTaskType["PRIMARY_ORDER_CANCELLED"] = "primary_order_cancelled";
    ReasonToCancelTaskType["RESCHEDULE"] = "reschedule";
})(ReasonToCancelTaskType || (exports.ReasonToCancelTaskType = ReasonToCancelTaskType = {}));
//# sourceMappingURL=reason_to_cancel_task.js.map